import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DISPATCH_STATUS_HINTS,
  DISPATCH_STATUS_LABELS,
  DISPATCH_STATUS_TONE,
} from '../utils/collectionReminders';

/**
 * Estado de un envío de recordatorio (fila de `dispatches`), con el mismo soft-pill que el
 * estado de pago. Los estados que no se explican solos ("Resultado incierto",
 * "Reintentando") llevan la aclaración en el title.
 */
export default function DispatchStatusBadge({ status, size = 'md', count }) {
  const { t } = useTranslation();
  const raw = DISPATCH_STATUS_LABELS[status];
  const label = raw ? t(raw) : status ?? '—';
  const tone = DISPATCH_STATUS_TONE[status] ?? 'neutral';
  const hint = DISPATCH_STATUS_HINTS[status];
  return (
    <span
      className={`bill-badge bill-badge--${tone}${size === 'sm' ? ' bill-badge--sm' : ''}`}
      title={hint ? t(hint) : undefined}
    >
      {label}
      {count !== undefined && <span className="tabular-nums">{count}</span>}
    </span>
  );
}
